import { rootApi } from "../../api/rootApi";

export const siteLocationsSBApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addSupplyBeamSiteLocations: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/supply-beam/site-locations/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    getSupplyBeamSiteLocations: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/supply-beam/site-locations`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const { useAddSupplyBeamSiteLocationsMutation,useGetSupplyBeamSiteLocationsMutation } = siteLocationsSBApi;
